import React, { useState, useEffect, useMemo } from "react"
import IconSortAsc from "../../assets/svg/inline/ic_sort_asc.svg"
import IconSortDesc from "../../assets/svg/inline/ic_sort_desc.svg"
import Select from 'react-select'

export default function Sort({currentValue, handleSortChange, sortReverse, type}) {
	
	//these default sort options are for the product page
    const sortByOptionsProducts = useMemo(() => {
		return [
			{value:'rate', label:'Rate'}, 
			{value:'propertytype', label:'Property type'}, 
			{value:'producttype', label:'Product type'}, 
			{value:'maxLtv', label:'Max LTV'}, 
			{value:'productFeePerc', label:'Product fee'}, 
			{value:'minLoan', label:'Min loan'}, 
			{value:'maxLoan', label:'Max loan'} 
	    ];
    }, [])  
  
    //sort options for max loan amount
    const sortByOptionsMaxLoanAmount = useMemo(() => {
		return [
			{value:'netLoanAmount', label:'Max net loan'}, 
			{value:'monthlyPayment', label:'Monthly interest payment'}, 
			{value:'rate', label:'Rate'}, 
			{value:'productFeeAmount', label:'Product fee'}, 
			{value:'adminFee', label:'Admin fee'}, 
			{value:'valuationFee', label:'Valuation fee'}, 
			{value:'totalCostOverInitialTerm', label:'Total cost'}, 
	    ];
    }, [])
    
    //sort options for max loan amount
    const sortByOptionsMinMonthlyRentalIncome = useMemo(() => {
		return [
			{value:'minRentalIncome', label:'Min rental income'}, 
			{value:'monthlyPayment', label:'Monthly interest payment'}, 
			{value:'rate', label:'Rate'}, 
			{value:'productFeeAmount', label:'Product fee'}, 
			{value:'adminFee', label:'Admin fee'}, 
			{value:'valuationFee', label:'Valuation fee'}, 
			{value:'totalCostOverInitialTerm', label:'Total cost'}, 
	    ];
    }, [])
    
    const [sortByOptions, setSortByOptions] = useState([]);
  
    /*decide which options we will sort by*/
    useEffect(() => {
		if (type==='Max loan amount') {
			setSortByOptions(sortByOptionsMaxLoanAmount);
		} else if (type==='Min monthly rental income') {
			setSortByOptions(sortByOptionsMinMonthlyRentalIncome);
		} else {//for products sort
			setSortByOptions(sortByOptionsProducts);
		}
    }, [type, sortByOptionsProducts, sortByOptionsMaxLoanAmount, sortByOptionsMinMonthlyRentalIncome]);
    
    const [selectedValueObj, setSelectedValueObj] = useState(false);

    useEffect(() => {
		setSelectedValueObj(sortByOptions.find(obj => obj.value===currentValue));
    }, [sortByOptions, currentValue]);
    
    return (
		<div className="sort">
			{sortByOptions && <>
				<Select 
					options={sortByOptions}
					placeholder={"Sort by"}
					className="react-select-container"
					classNamePrefix="react-select"
					components={{
					  IndicatorSeparator: () => null
					}}
					value={selectedValueObj}
					onChange={(option) => handleSortChange('sortBy', option.value)}
				/>
				<button className="plain" type="button" aria-label="Reverse" onClick={() => handleSortChange('sortReverse', !sortReverse)}>
				  {
					sortReverse
					? <IconSortDesc />
					: <IconSortAsc />
				  }				
				</button>
			</>}
		</div>
    )
}